"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = require("../store/Store");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var doesFolderIdEqualName_1 = require("owa-session-store/lib/utils/doesFolderIdEqualName");
var owa_trace_1 = require("owa-trace");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
function isLocalAvailableForSelectedNode() {
    var selectedNode = owa_mail_folder_forest_store_1.getSelectedNode();
    if (selectedNode.type == 2 /* Group */) {
        return true;
    }
    return !owa_mail_folder_forest_store_1.getFolderIdForSelectedNode();
}
/**
 * @returns [item to load based on selected folder, whether item is local, whether item is deleted].
 */
function findItemToLoad(conversationNode) {
    var itemCount = conversationNode && conversationNode.itemIds ? conversationNode.itemIds.length : 0;
    if (itemCount == 0) {
        return [null, false, false];
    }
    var foundItem = null;
    // If selected folder doesn't exist, treat item as a local item.
    var isLocal = isLocalAvailableForSelectedNode();
    var isDeleted = false;
    if (itemCount == 1) {
        foundItem = Store_1.default.items.get(conversationNode.itemIds[0]);
        if (!checkIfItemExists(conversationNode.itemIds[0], foundItem)) {
            return [null, false, false];
        }
        isLocal =
            isLocal ||
                (foundItem.ParentFolderId &&
                    foundItem.ParentFolderId.Id == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode());
    }
    else {
        var sentItem = null;
        for (var _i = 0, _a = conversationNode.itemIds; _i < _a.length; _i++) {
            var itemId = _a[_i];
            var item = Store_1.default.items.get(itemId);
            if (!checkIfItemExists(itemId, item)) {
                return [null, false, false];
            }
            if (item.ParentFolderId && item.ParentFolderId.Id == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode()) {
                foundItem = item;
                isLocal = true;
                break;
            }
            else if (doesFolderIdEqualName_1.default(item.ParentFolderId.Id, 'sentitems')) {
                sentItem = item;
            }
        }
        if (!foundItem) {
            foundItem = sentItem || Store_1.default.items.get(conversationNode.itemIds[0]);
        }
    }
    isDeleted = doesFolderIdEqualName_1.default(foundItem.ParentFolderId.Id, 'deleteditems');
    return [foundItem, isLocal, isDeleted];
}
exports.findItemToLoad = findItemToLoad;
function checkIfItemExists(itemId, item) {
    if (!itemId) {
        owa_trace_1.trace.error('ItemId in conversationNode.itemIds should not be:' + itemId);
        return false;
    }
    if (!item) {
        owa_trace_1.trace.error('Item should be in mailStore but does not exist.');
        return false;
    }
    return true;
}
function shouldCreateItemPartViewState(item, isDeleted, isLocal) {
    var userConfiguration = getUserConfiguration_1.default();
    var shouldHideDeletedItems = userConfiguration.UserOptions.HideDeletedItems;
    // No need to create view state for deleted drafts except for delete folder.
    // No need to create view state for deleted items when user setting has HideDeletedItems except for delete folder.
    return item && !((item.IsDraft || shouldHideDeletedItems) && isDeleted && !isLocal);
}
exports.shouldCreateItemPartViewState = shouldCreateItemPartViewState;
function getItemFromNodeId(nodeId) {
    var conversationNode = Store_1.default.conversationNodes.get(nodeId);
    var _a = findItemToLoad(conversationNode), item = _a[0], isLocal = _a[1], isDeleted = _a[2];
    if (!shouldCreateItemPartViewState(item, isDeleted, isLocal)) {
        return null;
    }
    else {
        return item;
    }
}
exports.getItemFromNodeId = getItemFromNodeId;
//# sourceMappingURL=conversationsUtils.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/utils/conversationsUtils.js
// module id = 2917
// module chunks = 4 8 78